import { isEqual } from 'lodash-es'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'

import { AddressFields } from '@/components/AddressFields'
import type { FieldInputProps } from './fieldInputProps'
import type { AddressValue } from './screenForm'

/** AddressFields on a small form of its own, whose every change goes up to the screen's answers. */
export function AddressField({ field, value, onChange, disabled }: FieldInputProps<AddressValue>) {
  const { control, setValue, subscribe, getValues, reset } = useForm<AddressValue>({ defaultValues: value })
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(
    () =>
      subscribe({
        formState: { values: true },
        callback: ({ values: next }) => onChangeRef.current({ ...next }),
      }),
    [subscribe]
  )

  // A reset of the screen's answers comes back down.
  useEffect(() => {
    if (!isEqual(value, getValues())) reset(value)
  }, [value, getValues, reset])

  return (
    <AddressFields
      control={control}
      setValue={setValue}
      names={{ line1: 'line1', line2: 'line2', city: 'city', state: 'state', zip: 'zip' }}
      required={field.required}
      label={field.label}
      line1Placeholder={field.placeholder || undefined}
      lockedState={field.lockedState || undefined}
      disabled={disabled}
    />
  )
}
